import styled from "@emotion/styled";
import { useField } from "formik";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const ToggleButtons = ({ name, options, defaultValue = "", color = "secondary", ...props }) => {
  const [ field, meta, helpers ] = useField(name);

  const handleChange = (e, val) => {
    helpers.setValue(val);
  };

  return (
    <ToggleButtonGroup value={field.value} onChange={handleChange} defaultValue={defaultValue} exclusive fullWidth size="small" color={color} {...props}>
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
};

export default ToggleButtons;